import trans from "../trans";
import { Language } from "../types";
import { useFeatureServices } from "../use-feature-services";

const useTrans = () => {
    const { 'locale-service': localeService } = useFeatureServices();

    return trans(localeService.language as unknown as Language);
}

export default useTrans;
